import React, { useState } from 'react'
import { Autocomplete } from '@material-ui/lab'
import { TextField } from '@material-ui/core'

interface QuestionProps {
  data: {
    id: number
    title: string
    note: string
    answers: { title: string; value: number }[]
    answer: null
    type: string
    label: string
  }[]
  handleClick: () => void
}

export const Question = ({ data, handleClick }: QuestionProps) => {
  const [selectedAnswer, setSelectedAnswer] = useState(data.selectedAnswer)

  const handleChange = (e, v) => {
    handleClick(v.value)
  }

  return (
    <div className='question-container'>
      <div className='question-header'>
        <div className='ui text container center aligned'>
          <div
            className='title'
            dangerouslySetInnerHTML={{ __html: data.title }}
          />
          <div className='note'>{data.note && data.note}</div>
        </div>
      </div>
      <div className={`answers${data.type === 'autocomplete' ? ' solo' : ''}`}>
        {data.type === 'autocomplete' ? (
          <div className='ui text center aligned container'>
            <Autocomplete
              className='answer-autocomplete'
              options={data.answers}
              getOptionLabel={option => option.title}
              value={
                null
                /*
                Disabled so user can send the choice again
                data.answer
                  ? data.answers.find(d => d.value === data.answer)
                  : null
                  */
              }
              onChange={handleChange}
              renderInput={params => (
                <TextField {...params} label={data.label} variant='outlined' />
              )}
              autoSelect
              blurOnSelect
              disableClearable
              noOptionsText={data.noResultMessage}
            />
            <div className='note' />
          </div>
        ) : (
          data.answers.map((a, i) => (
            <div
              className={`answer${
                data.answer === selectedAnswer ? ' selected' : ''
              }`}
              key={`answer-${i}`}
              onClick={() => {
                setSelectedAnswer(a.value)
                handleClick(a.value)
              }}
            >
              <i
                className={`circle ${
                  data.answer === a.value ? 'check' : 'outline'
                } icon`}
              />{' '}
              {a.title}
            </div>
          ))
        )}
      </div>
    </div>
  )
}
